import UserHealthInfo from 'components/healthScore/UserHealthInfo'

const HealthScore = () => {
  return <UserHealthInfo />
}

export default HealthScore
